import { graphql } from "@myvp/shared/src/gql"
import { Beacon } from "@myvp/shared/src/gql/graphql"
import { graphqlClient } from "@myvp/shared/src/functions/request"

export const saveBeacons = async (args: { beacons: Beacon[] }) => {
  const mutation = graphql(/*GraphQL*/ `
    mutation saveBeacons($input: SaveBeaconsInput!) {
      saveBeacons(input: $input) {
        success
      }
    }
  `)
  const result = await graphqlClient.request(mutation, {
    input: {
      beacons: args.beacons,
    },
  })
  return result.saveBeacons
}
